<template>
<div>
    <header class="modal-header">
        <div class="tit"></div>
        <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>
    <!-- 인증번호 입력 창 시작 -->
    <div class="modal-content">
        <div class="mbs-right">
                <fieldset style="width:300px">
                    <div class="input-box">
                        <input
                            type="number"
                            id="otp"
                            name="otp"
                            v-model="otp"
                            v-validate="'required'"
                            :placeholder="$i18nUtil.trans('message.placeholder.otp', '인증번호')"
                            @focus="$event.target.placeholder=''"
                            @focusout="$event.target.placeholder=$i18nUtil.trans('message.placeholder.otp', '인증번호')"
                            maxlength="6"
                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                        />
                        <span class="time" v-if="countDown !== null" :style="$i18nUtil.getLanguage() === 'en' ? 'right: 110px;' : ''">
                            <span>{{ countDown }}</span>
                        </span>
                        <!-- 2021-09-09 전송 버 튼 삭제 & 재전송 -> 재요청 기능 변경 및 버튼명 변경 -->
                        <button type="button" class="btn-primary-small" @click="produceOtp()">{{ $i18nUtil.trans("button.re.req", "재요청") }}</button>
                            {{otpNum}}
                        <div class="error" v-if="errors.has('otp') || otpEmpty">{{ $i18nUtil.trans("UB044", "인증번호를 입력해주세요.") }}</div>
                    </div>
                    <div class="certification-txt">{{ $i18nUtil.trans("message.IntegrateLogin.012", "* 모바일 폰에서 발급받은 인증번호를 입력 후 진행해주세요.") }}</div>
                    <button type="button" class="btn_login" @click="compareOtp">{{ $i18nUtil.trans("button.confirm", "확인") }}</button>
                </fieldset>
                <!-- 인증번호 입력 창 끝 -->
        </div>
    </div>
</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
export default {

    data() {
        return {
            minutes: 0,
            secondes: 0,
            time: 300,
            timer: null,
            otp: "",
            otpId : null,
            type : "SMS",
            userId : "",
            password : "",
            accessDevice : false,
            otpEmpty: false,
            domain : location.host,
            reOtpId : null,
            otpNum:this.modalInfo.otpNum
        }
    },
    props: {
        modalInfo: {
            type : Object,
            default: null
        }
    },
    mounted(){
this.handleCountDown();
    },
    computed: {
        /* OTP 인증 시간 */
        countDown() {
            let time = this.time / 60;
            let minutes = parseInt(time);
            let secondes = Math.round((time - minutes) * 60);

            let min = minutes;
            let sec = secondes;
            if (min < 10) {
                min = "0" + min;
            }
            if (sec < 10) {
                sec = "0" + sec;
            }
            return min + " : " + sec;
        }
    },
    methods: {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        ...mapActions("modals", ["showDialog", "showModal"]),

        produceOtp() {
            let obj = this;
            let reqData = {
                url: "/api/auth/produceOtp",
                method: "post",
                params: {
                    otpId: obj.otpId,
                    userId: localStorage.getItem('userId'),
                    certType : obj.type,
                    password: '',
                    accessDevice : obj.accessDevice
                }
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                if(res.errorCode !== null) {
                    let errorCode = res.errorCode;
                    if(errorCode === "NOT_EXIST_CELL_PHONE_NO") {
                        let info = {
                            title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                            contents: obj.$i18nUtil.trans("message.IntegrateLogin.011", "핸드폰 번호가 존재하지 않습니다."),
                            button: obj.$i18nUtil.trans("button.dialog.confirm", "확인")
                        };
                        obj.handleDialog(info);
                    }
                } else {
                    if (res.result.otpId != null) {
                        obj.otpInputField = true;
                        obj.isValidPw = true;
                        obj.resOtp = res.result.otp;
                        obj.otpId = res.result.otpId;
                        obj.time = 300;
                        obj.handleCountDown();
                        
                        //dev or stg일 경우 OTP번호 노출
                        if(res.result.otp != null){
                            obj.otpNum = res.result.otp;
                            console.log("재요청 OPT 번호 :: " + res.result.otp);
                        }
                        
                        let info = {
                            title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                            contents: obj.$i18nUtil.trans("AG014", "인증번호가 전송되었습니다."),
                            button: obj.$i18nUtil.trans("button.dialog.confirm", "확인")
                        };
                        obj.handleDialog(info);
                    }
                }
            })
            .catch(function(err) {
                console.log(err);
            });
            
        },
        /* OTP 인증 만료 시간 */
        handleCountDown(timer) {
            if (timer !== null) {
                clearInterval(this.timer);
                this.timer = setInterval(() => {
                    if (this.time > 0) {
                        this.time--;
                    } else {
                        clearInterval(this.timer);
                    }
                }, 1000);
            } else {
                this.timer = setInterval(() => {
                    if (this.time > 0) {
                        this.time--;
                    } else {
                        clearInterval(this.timer);
                    }
                }, 1000);
            }
        },
        /* 인증번호 비교 및 로그인 */
        compareOtp() {
            if (this.time === 0) {
                let info = {
                    title: this.$i18nUtil.trans("title.dialog.notice", "알림"),
                    contents: this.$i18nUtil.trans("AG015", "인증번호 입력시간이 초과되었습니다.\n인증번호 재전송 후 다시 입력해주세요."),
                    button: this.$i18nUtil.trans("button.dialog.confirm", "확인")
                };
                this.handleDialog(info);
            } else {
                if (this.otp !== undefined && this.otp !== "") {
                    let obj = this;
                    if(obj.otpId == null){
                        obj.reOtpId = obj.modalInfo.otpId;
                    }else{
                        obj.reOtpId = obj.otpId;
                    }
                    let reqData = {
                        url: "/api/auth/compareOtp",
                        method: "post",
                        params: {
                            otp: obj.otp,
                            otpId: obj.reOtpId,
                            userId: localStorage.getItem('userId'),
                            isLdap: obj.isLdap,
                            domain: obj.domain,
                            isManage:true,
                            dormantYn:false
                        }
                    };
                    
                    obj
                    .COWORK_REST_SIMPLE_ACTION(reqData)
                    .then(function(res) {
                    if (res.errorCode !== null) {
                        let errorCode = res.errorCode;
                        if (errorCode === "AG017") {
                            let info = {
                                title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                                contents: obj.$i18nUtil.trans("AG017", "인증번호가 일치하지 않습니다.\n인증번호를 확인 후 다시 시도해주세요."),
                                button: obj.$i18nUtil.trans("button.dialog.confirm", "확인")
                            };
                            obj.handleDialog(info);
                        }
                    } else {
                        let curUrl = localStorage.getItem("returnUrl");
                        let cosysUrl = "cosys";
                        //관리자 페이지 이동
                        if(curUrl!=null){
                            if(curUrl.includes(cosysUrl)){
                            obj.$router.go();
                            }else{
                            obj.$router.push("/cosys/fileDlpBlock");
                            }
                        }else{
                            obj.$router.push("/cosys/fileDlpBlock");
                        }
                       
                    }
                    })
                    .catch(function(err) {
                    console.log(err);
                    });
                } else {
                    this.otpEmpty = true;
                   
                }
            }
        },
        handleDialog(info) {
            const dialogInfo = {
                obj: this.$modal,
                component: Dialog,
                title : info.title,
                button : info.button,
                contents : info.contents
            };
            this.showDialog(dialogInfo);
        },
    }
}
</script>
<style scoped>
.mbs-right {
    padding-right: 385px;
}
.input-box {
    margin-top: 50px;
}
.certification-txt{
    padding-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/cowork/general/main/modal/ManagerOtp.vue